import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { recyclItem, announceChannelData, serverList } from '@/api/gmToolNew/gmToolNew';
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
export default {
  mixins: [gmToolNew, gmToolNewPage],
  props: {},
  data: function data() {
    return {
      sendData: {
        desc: [{
          role_id: '',
          server_id: '',
          server_channel: '',
          show_test: '',
          env_id: '',
          serverChannel: [],
          serverListYJ: [],
          item_list: [{
            item_id: '',
            item_num: '',
            quality: '',
            star: ''
          }]
        }],
        sender: '',
        contents: '',
        language: '',
        title: '',
        expire: ''
      },
      dialogShow: false,
      rules: {
        sender: [{
          required: true,
          message: this.$t('pleaseEnterSender'),
          trigger: "blur"
        }],
        role_id: [{
          required: true,
          message: this.$t('pleaseEnterRoleId'),
          trigger: "blur"
        }],
        item_id: [{
          required: true,
          message: this.$t('pleaseEnterItemId'),
          trigger: "blur"
        }],
        item_num: [{
          required: true,
          message: this.$t('pleaseEnterQuantity'),
          trigger: "blur"
        }],
        title: [{
          required: true,
          message: this.$t('pleaseEnterTitle'),
          trigger: "blur"
        }],
        server_id: [{
          required: true,
          message: this.$t('pleaseSelectServer'),
          trigger: "blur"
        }],
        contents: [{
          required: true,
          message: this.$t('pleaseEnterEmailContent'),
          trigger: "blur"
        }],
        language: [{
          required: true,
          message: this.$t('pleaseSelectLanguage'),
          trigger: "blur"
        }],
        expire: [{
          required: true,
          message: this.$t('pleaseSelectExpireTime'),
          trigger: "blur"
        }]
      },
      issubmit: false
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      this.dialogShow = true;

      if (data) {// this.sendData = d
      }
    },
    hiad: function hiad() {
      this.dialogShow = false;
    },
    addtag: function addtag(data, index) {
      this.sendData.content_Val[index].contents = "".concat(this.sendData.content_Val[index].contents).concat(data);
    },
    addDomain: function addDomain() {
      this.sendData.desc.push({
        role_id: '',
        server_id: '',
        server_channel: '',
        show_test: '',
        env_id: '',
        serverChannel: [],
        serverListYJ: [],
        item_list: [{
          item_id: '',
          item_num: '',
          quality: '',
          star: ''
        }]
      });
    },
    removeDomain: function removeDomain(item) {
      var index = this.sendData.desc.indexOf(item);

      if (index !== -1) {
        this.sendData.desc.splice(index, 1);
      }
    },
    addItem: function addItem(index) {
      this.sendData.desc[index].item_list.push({
        item_id: '',
        item_num: '',
        quality: '',
        star: ''
      });
    },
    removeItem: function removeItem(index, indexs) {
      this.sendData.desc[index].item_list.splice(indexs, 1);
    },
    clearData: function clearData() {
      this.sendData = {
        desc: [{
          role_id: '',
          server_id: '',
          server_channel: '',
          show_test: '',
          serverChannel: [],
          serverListYJ: [],
          item_list: [{
            item_id: '',
            item_num: '',
            quality: '',
            star: ''
          }]
        }],
        sender: '',
        contents: '',
        language: '',
        title: '',
        expire: ''
      };
      this.$refs.ruleForm.clearValidate();
    },
    envIdChange: function envIdChange(index) {
      this.sendData.desc[index].serverChannel = [];
      this.sendData.desc[index].server_channel = "";
      this.sendData.desc[index].show_test = "";
      this.sendData.desc[index].server_id = "";
      this.sendData.desc[index].serverListYJ = [];
      this.getannounceChannelData(index);
    },
    getannounceChannelData: function getannounceChannelData() {
      var _this = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (!this.sendData.desc[index].env_id) {
        return;
      }

      announceChannelData({
        env_id: this.sendData.desc[index].env_id,
        game_id: this.rawData.game_id,
        page_size: 10,
        page: 1
      }).then(function (res) {
        if (res.status == 200) {
          res.data.map(function (i) {
            i.label = i.announce_channel_name;
            i.value = i.announce_channel_mark;
          });
          _this.sendData.desc[index].serverChannel = res.data || [];
        }
      });
    },
    serverChannelChange: function serverChannelChange(index) {
      var ismessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.sendData.desc[index].server_id = "";
      this.sendData.desc[index].serverListYJ = [];

      if (!this.sendData.desc[index].server_channel) {
        ismessage && this.$message.error(this.$t('pleaseSelectServerChannel'));
        return;
      }

      if (this.sendData.desc[index].show_test === "") {
        return;
      }

      this.getServerList(index);
    },
    getServerList: function getServerList(index) {
      var _this2 = this;

      var _this$sendData$desc$i = this.sendData.desc[index],
          env_id = _this$sendData$desc$i.env_id,
          server_channel = _this$sendData$desc$i.server_channel,
          show_test = _this$sendData$desc$i.show_test;
      serverList({
        server_channel: server_channel,
        show_test: show_test,
        env_id: env_id,
        game_id: this.rawData.game_id
      }).then(function (res) {
        if (res.code == 200) {
          _this2.sendData.desc[index].serverListYJ = res.data;
        }
      });
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this3.issubmit = true;
          var data = JSON.parse(JSON.stringify(_this3.sendData));
          var emailPramsData = {
            game_id: _this3.rawData.game_id,
            sender: _this3.sendData.sender,
            contents: _this3.sendData.contents,
            language: _this3.sendData.language,
            title: _this3.sendData.title,
            expire: _this3.sendData.expire,
            list: []
          };
          data.desc.forEach(function (item) {
            item.item_list.forEach(function (m) {
              if (m.star !== "") {
                emailPramsData.list.push({
                  item_num: m.item_num,
                  item_id: m.item_id,
                  quality: m.quality,
                  star: m.star,
                  server_id: item.server_id,
                  role_id: item.role_id,
                  env_id: item.env_id
                });
              } else {
                emailPramsData.list.push({
                  item_num: m.item_num,
                  item_id: m.item_id,
                  quality: m.quality,
                  server_id: item.server_id,
                  role_id: item.role_id,
                  env_id: item.env_id
                });
              }
            });
          });
          recyclItem(emailPramsData).then(function (res) {
            if (res.status == 200) {
              _this3.$message({
                message: _this3.$t('operationSuccess'),
                type: 'success'
              });

              _this3.dialogShow = false;

              _this3.$emit('change');
            }
          }).finally(function () {
            _this3.issubmit = false;
          });
        }
      });
    }
  }
};